import React, { useEffect, useRef, useState } from 'react';

/**
 * EuropcarGoogleIsimReport: Europcar & Goldcar Google İşletme Profili kayıt adlarının
 * kurumsal isim kural setine göre denetimi + uymayanlara ad önerisi.
 * Route: /r/europcar-google-isim (ProtectedRoute allowBrandIds Europcar, sidebar'da VAR)
 *
 * İçerik statik: 23 Eyl 2026'da GBP API'den çekilen kayıtlar, ofis listesine elle eşlendi.
 * Yeniden üretmek için: node src/pages/europcar-google-isim/build.js
 * srcDoc izolasyonu şart — rapor global seçiciler taşıyor.
 */
export default function EuropcarGoogleIsimReport() {
  const [html, setHtml] = useState(null);
  const [height, setHeight] = useState(720);
  const boxRef = useRef(null);

  useEffect(() => {
    let alive = true;
    import('./europcarGoogleIsimHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  // iframe'i içerik alanının kalan yüksekliğine oturt. Rapor kendi içinde kayar,
  // sayfa gövdesi kaymaz — iki kaydırma çubuğu üst üste binmesin.
  useEffect(() => {
    const fit = () => {
      const top = boxRef.current?.getBoundingClientRect().top ?? 0;
      setHeight(Math.max(480, window.innerHeight - top - 16));
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [html]);

  return (
    <div ref={boxRef} className="px-2 pb-2">
      {html ? (
        <iframe
          title="Europcar · Google Kayıt Adları"
          srcDoc={html}
          style={{
            width: '100%',
            height,
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            display: 'block',
            background: '#F6F8FF',
          }}
        />
      ) : (
        <div
          style={{ height, borderRadius: 12, background: '#F6F8FF' }}
          aria-busy="true"
        />
      )}
    </div>
  );
}
